import { render, staticRenderFns } from "./MapPolygons.vue?vue&type=template&id=63fc9e5e"
import script from "./MapPolygons.vue?vue&type=script&lang=ts"
export * from "./MapPolygons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports